import React from "react";
import styled from "styled-components";

const StyledSpan = styled.span`
  color: red;
`;

const ValidMsgSpan = ({ value, className = "f11" }) => {
  return <StyledSpan className={`${className}`}>{value}</StyledSpan>;
};

export default ValidMsgSpan;
